export const aiImageStyleTypeLabels = [
  { key: 'isometric_anime', label: 'isometric anime' },
  { key: 'analytic_drawing', label: 'analytic drawing' },
  { key: 'infographic_drawing', label: 'infographic drawing' },
  { key: 'coloring_book', label: 'coloring book' },
  { key: 'diagrammatic_drawing', label: 'diagrammatic drawing' },
  { key: 'diagrammatic_portrait', label: 'diagrammatic portrait' },
  { key: 'double_exposure', label: 'double exposure' },
  { key: 'two_d_illustration', label: '2D illustration' },
  { key: 'isometric_illustration', label: 'isometric illustration' },
  { key: 'pixel_art', label: 'pixel art' },
  { key: 'futuristic_style', label: 'futuristic style' },
  { key: 'ornamental_watercolor', label: 'ornamental watercolor' },
  { key: 'dark_fantasy', label: 'dark fantasy' },
  { key: 'paper_cut_craft', label: 'paper cut craft' },
  { key: 'paper_quilling', label: 'paper quilling' },
  { key: 'patchwork_collage', label: 'patchwork collage' },
  { key: 'iridescent', label: 'iridescent' },
  { key: 'ukiyo_e_art', label: 'ukiyo-e art' },
  { key: 'watercolor_landscape', label: 'watercolor landscape' },
  { key: 'op_art', label: 'op art' },
  { key: 'japanese_ink', label: 'Japanese ink' },
  { key: 'pastel_drawing', label: 'pastel drawing' },
  { key: 'dripping_art', label: 'dripping art' },
  { key: 'stained_glass_portrait', label: 'stained glass portrait' },
  { key: 'graffiti_portrait', label: 'graffiti portrait' },
  { key: 'winter_oil_painting', label: 'winter oil painting' },
  { key: 'anime_portrait', label: 'anime portrait' },
  { key: 'cinematographic_style', label: 'cinematographic style' },
  { key: 'typography_art', label: 'typography art' },
  { key: 'one_line_drawing', label: 'one-line drawing' },
  { key: 'polaroid_photo', label: 'polaroid photo' },
  { key: 'tattoo_art', label: 'tattoo art' },
  { key: 'realism_photography', label: 'realism photography' }
].sort((a, b) => a.label.localeCompare(b.label));
